import { Alert, Empty, Skeleton } from 'antd'
import { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { fetchPublicCategory, fetchPublicTopic, type PublicApiError, type PublicItemSummary } from './publicApi'

export default function PublicTermDetailPage({
  workspaceSlug,
  siteSlug,
  kind,
}: {
  workspaceSlug: string
  siteSlug: string
  kind: 'category' | 'topic'
}) {
  const { slug = '' } = useParams()
  const [term, setTerm] = useState<{ slug: string; name: string; description: string } | null>(null)
  const [items, setItems] = useState<PublicItemSummary[] | null>(null)
  const [error, setError] = useState<string | null>(null)
  const base = `/site/${workspaceSlug}/${siteSlug}`

  useEffect(() => {
    setTerm(null)
    setItems(null)
    setError(null)
    const fetcher = kind === 'category' ? fetchPublicCategory : fetchPublicTopic
    fetcher(workspaceSlug, siteSlug, slug)
      .then((r) => {
        setTerm(r.data.term)
        setItems(r.data.items)
      })
      .catch((err) => setError((err as PublicApiError).message))
  }, [workspaceSlug, siteSlug, slug, kind])

  if (error) return <div className="pub-page"><Alert type="error" message={error === 'Not Found' ? '未找到' : error} showIcon /></div>
  if (!term) return <div className="pub-page"><Skeleton active paragraph={{ rows: 6 }} /></div>

  return (
    <div className="pub-page">
      <h1>{term.name}</h1>
      {term.description && <p style={{ color: '#666' }}>{term.description}</p>}
      {items === null ? (
        <Skeleton active paragraph={{ rows: 4 }} />
      ) : items.length === 0 ? (
        <Empty className="pub-empty" description="暂无条目" />
      ) : (
        <div className="pub-grid" style={{ marginTop: 24 }}>
          {items.map((item) => (
            <Link key={item.slug} to={`${base}/items/${item.slug}`} className="pub-card">
              <div className="pub-card-cover">{item.cover_url && <img src={item.cover_url} alt={item.label} />}</div>
              <div className="pub-card-body">
                <p className="pub-card-title">{item.label}</p>
                <p className="pub-card-meta">{item.creator || item.era || item.accession_number}</p>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  )
}
